import React from 'react';
import { useTranslation } from 'react-i18next';
import { Line, LineChart, YAxis } from 'recharts';
import { PROP } from '../../../../../constant';

function dataSet(d) {
  const dTemp = d.split(":");
  // const dTemp = "v2:3.7".split(":");
  const result = {
    center: 0,
    data: []
  }

  if (dTemp[0] === 'v2') {
    // result.center = 0.078950158;
    result.center = Number(dTemp[1]);
    PROP.CHART_XY.forEach((v) => {
      result.data.push({
        "top": 0.4,
        "middle": 0.2,
        "bottom": 0,
        "ux": v.x,
        "uv": v.y,
      })
    });
  } else {
    if (dTemp.length > 0) {
      dTemp.forEach((item) => {
        const iTemp = item.split(",");
        if (Number(iTemp[0]) === 0) {
          result.center = Number(iTemp[1]);
        };
        result.data.push({
          "top": 100,
          "middle": 66.7,
          "bottom": 0,
          "uv": Number(iTemp[1]),
        })

      })
    }
  }

  return result;
}

function PrecisionChart({ result }) {
  const { t, i18n } = useTranslation();
  let data = [];
  let version = 'v1';
  if (result?.calclAcrcyCordn) {
    data = dataSet(result.calclAcrcyCordn);
    if (result.calclAcrcyCordn.split(":")[0] === 'v2') version = 'v2';
  }

  const activeRenderDot = (dotValue) => {
    const { cx, cy, payload } = dotValue;
    if (version === 'v2') {
      if (payload.ux !== data.center) return;
    } else {
      if (payload.uv !== data.center) return;
    }

    // 80 135 234

    setTimeout(() => {
      const dom = document.getElementById('result-tooltip');
      const domDot = document.getElementById('result-dot');
      const domLine = document.getElementById('charts-dottedLine');

      const domMin = document.getElementById('result-min');
      const domMax = document.getElementById('result-max');

      if (dom && domDot && domLine) {
        // AI 추천학습 말풍선
        dom.style.display = "";
        // dom.style.display = "none";
        dom.style.zIndex = 2;
        dom.style.left = `${cx - 10}px`
        dom.style.top = `${cy - 105}px`;
        dom.style.transform = "translate(-50%, 15px)";

        // 평균 중앙 포인트
        domDot.style.display = "";
        domDot.style.zIndex = 2;
        domDot.style.left = `${cx - 5}px`;
        domDot.style.top = `${cy - 5}px`

        // 평균 중앙 라인
        domLine.style.display = "";
        domLine.style.left = `${cx - 1}px`;
        domLine.style.top = '25px';

        if (version === 'v2') {

          // 하위 영역
          domMin.style.display = "";
          domMin.style.top = '25px';

          // 상위 영역
          domMax.style.display = "";
          domMax.style.top = '25px'
          domMax.style.right = `${document.getElementsByClassName('charts-cont')[0].offsetWidth
            - document.getElementsByClassName('recharts-wrapper')[0].offsetWidth}px`;
        }
      }
    })

    return null;
  }

  const yLineTitle = (e) => {
    if (version === 'v2') {
      if (e === 0.4) return '';
      else if (e === 0.2) return '';
      else if (e === 0) return '';
    } else {
      if (e === 100) return t("LC_02_09_result.msg030");
      else if (e === 66) return t("LC_02_09_result.msg031");
      else if (e === 0) return t("LC_02_09_result.msg032");
    }
  }

  return (
    <React.Fragment>
      <div className="charts-label">
        {
          version === 'v2'
            ? (
              <p className="charts-tit sky">{t("LC_02_09_result.msg033")}</p>
            )
            : (
              <p className="charts-tit sky">{t("LC_02_09_result.msg008")}</p>
            )
        }
        <p className="charts-txt">{t("LC_02_09_result.msg009")}</p>
      </div>
      <div className="charts-item">
        {
          version !== 'v2' ? (
            <p className="charts-yAxis">{t("LC_08_02-GM.msg023")}</p>
          ) : (
            <p className="charts-yAxis">{t("LC_08_02-GM.msg024")}</p>
          )
        }
        <div
          className="charts-dottedLine"
          id="charts-dottedLine"
          style={{ display: 'none' }}
        />
        <div
          id="result-dot"
          className="charts-hover-bullet"
          style={{
            display: 'none',
            position: 'absolute'
          }}
        >
          <span className="point"></span>
        </div>
        <div
          id="result-min"
          style={{
            display: 'none',
            position: 'absolute',
            left: i18n.language === 'en' ? 55 : 30,
            margin: 0,
            background: '#f05a46',
            maxWidth: 234,
            height: 140,
            minWidth: 50,
            whiteSpace: 'pre',
            opacity: '0.2'
          }}
        />
        <div
          id="result-max"
          style={{
            display: 'none',
            position: 'absolute',
            right: 0,
            margin: 0,
            background: '#00dcff',
            maxWidth: 234,
            height: 140,
            minWidth: 50,
            whiteSpace: 'pre',
            opacity: '0.2'
          }}
        />
        <div
          id="result-tooltip"
          className="charts-tooltip"
          style={{
            display: 'none',
            position: 'absolute',
            padding: 10,
            zIndex: 1,
            margin: 10,
            maxWidth: 234,
            minWidth: 80,
            height: version === 'v2' ? 35 : 60,
            whiteSpace: 'pre',
          }}
        >
          {
            version === 'v2'
              ? <p className="tit"><b>{t("LC_02_09_result.msg036")}</b></p>
              : (
                <>
                  <p className="tit">{t("LC_02_09_result.msg020")}</p>
                  <span className="txt">{result.estPreStgNm}</span>
                </>
              )
          }
        </div>
        <LineChart
          width={276}
          height={172}
          data={data?.data}
          margin={{ top: 25, bottom: 12 }}
        >
          {
            version === 'v2'
              ? (
                <YAxis
                  width={i18n.language === 'en' ? 55 : 30}
                  tick={{ fontSize: 12, fill: '#788ca0' }}
                  ticks={[0.4, 0.2, 0]}
                  tickFormatter={yLineTitle}
                />
              )
              : (
                <YAxis
                  width={i18n.language === 'en' ? 55 : 30}
                  tick={{ fontSize: 12, fill: '#788ca0' }}
                  ticks={[100.1, 100, 66, 0]}
                  tickFormatter={yLineTitle}
                />
              )
          }

          <Line
            storke
            type="monotone"
            dataKey="top"
            stroke="#466482"
            dot={false}
            activeDot={false}
            strokeWidth={1}
            strokeDasharray="6 6"
          />
          <Line
            type="monotone"
            dataKey="middle"
            stroke="#466482"
            dot={false}
            activeDot={false}
            strokeWidth={2}
          />
          <Line
            type="monotone"
            dataKey="bottom"
            stroke="#466482"
            strokeDasharray="6 6"
            dot={false}
            activeDot={false}
            strokeWidth={1}
          />
          <Line
            type="monotone"
            dataKey="uv"
            stroke="#00dcff"
            strokeWidth={4}
            dot={activeRenderDot}
          />
        </LineChart>
        {
          version === 'v2'
            ? (
              <div className="moreInfoBox" style={{ justifyContent: 'space-between', alignItems: 'center', display: 'flex' }}>
                <p className="charts-xAxis right" style={{ color: "#f05a46" }}>{t("LC_02_09_result.msg034")}</p>
                <p className="charts-xAxis right" style={{ color: "#00c3e1" }}>{t("LC_02_09_result.msg035")}</p>
              </div>
            )
            : (
              <div className="moreInfoBox">
                <p className="charts-xAxis right">{t("LC_02_09_result.msg011")}</p>
              </div>
            )
        }
      </div>
      <div className="charts-btm">
        {
          version === 'v2'
            ? <p className="txt">{t("LC_02_09_result.msg037")}</p>
            : <p className="txt">{t("LC_02_09_result.msg013")}</p>
        }
      </div>
    </React.Fragment>
  );
}

export default PrecisionChart;
